export enum LobbyType {
    Credit,
    Cash,
}
